<template>
  <div class="popup_button_ok popup_button_ok-freespins">
    <div class="popup_button_ok-freespins-box" @click="onCloseClick">
      <DefaultButton :text="text" />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import DefaultButton from '@/components/otherComponents/DefaultButton.vue';

export default Vue.extend({
  name: 'ButtonPopup',
  components: {
    DefaultButton
  },
  props: {
    text: String,
    closePopup: Boolean
  },
  methods: {
    onCloseClick(): void {
      if (this.closePopup) this.$emit('closePopup');
      else this.$emit('getOtherGame');
    }
  }
});
</script>

<style scoped>
.popup_button_ok-freespins-box {
  cursor: pointer;
  display: inline-block;
  transition: all 0.08s ease;
}

.popup_button_ok-freespins-box:hover {
  transform: scale(1.05);
}

.popup_button_ok-freespins-box:active {
  transform: scale(0.95);
}

.popup_button_ok:hover {
  transform: scale(1);
  cursor: auto;
}

.popup_button_ok:active {
  transform: scale(1);
  cursor: auto;
}
</style>
